import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { colors, font } from '../../design/tokens'
import logoLigier from '../../assets/logo_ligier.png'

// Shell mobile-first de la app de BI (separada del menú operativo de LGR).
// Vive dentro de LGR (mismo login) pero con layout propio, pensada para el celular
// y para ir sumando reportes. Acceso: solo administradores.
const ROLES_BI = ['administrador', 'super_administrador']

export default function BiAppLayout({ children }) {
  const { user, hasAnyRole, logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const enHome = location.pathname === '/panel' || location.pathname === '/panel/'

  if (!hasAnyRole(ROLES_BI)) {
    return (
      <div style={{ ...wrap, alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 32 }}>
        <div>
          <img src={logoLigier} alt="Ligier" style={{ height: 40, marginBottom: 16, opacity: 0.8 }} />
          <p style={{ color: colors.textSec, fontFamily: font.sans }}>Esta app de BI es solo para dirección.</p>
          <button onClick={() => navigate('/dashboard')} style={linkBtn}>Ir a LGR</button>
        </div>
      </div>
    )
  }

  return (
    <div style={wrap}>
      <header style={header}>
        {enHome ? (
          <img src={logoLigier} alt="Ligier" style={{ height: 26 }} />
        ) : (
          <button onClick={() => navigate('/panel')} style={iconBtn} aria-label="Inicio">←</button>
        )}
        <span style={{ fontFamily: font.sans, fontWeight: 700, fontSize: 15, letterSpacing: '0.04em', color: colors.text }}>
          BI <span style={{ color: colors.textMeta, fontWeight: 500 }}>Ligier</span>
        </span>
        <button onClick={logout} style={iconBtn} aria-label="Salir" title={user?.nombre || user?.email}>⏻</button>
      </header>
      <main style={main}>{children}</main>
    </div>
  )
}

const wrap = { minHeight: '100dvh', background: colors.bgSoft, display: 'flex', flexDirection: 'column' }
const header = {
  position: 'sticky', top: 0, zIndex: 10, background: colors.bg,
  borderBottom: `1px solid ${colors.border}`, height: 52,
  display: 'grid', gridTemplateColumns: '40px 1fr 40px', alignItems: 'center',
  padding: '0 12px', maxWidth: 560, width: '100%', margin: '0 auto',
}
const main = { flex: 1, width: '100%', maxWidth: 560, margin: '0 auto', padding: '14px 12px 32px', boxSizing: 'border-box' }
const iconBtn = { border: 'none', background: 'transparent', fontSize: 18, color: colors.textSec, cursor: 'pointer', padding: 6 }
const linkBtn = { marginTop: 16, padding: '9px 18px', borderRadius: 8, border: `1px solid ${colors.border}`, background: colors.bg, color: colors.link, fontWeight: 600, cursor: 'pointer' }
